<style scoped>
  .selected { font-weight: bold }
  li { cursor: pointer }
</style>

<template>
  <div class="variationsBlock sizeDropBlock row align-items-center">
    <div class="col-3">
      <span class="attr-title" v-html="`${variationGroup.variationGroupName}`"></span>
    </div>
    <div class="col-6 p-0">
      <button class="selectDropSize" v-on:click="visible = !visible">{{ getSelectedText || t('selection') }}
        <i class="lni lni-chevron-down"></i>
      </button>
      <div v-show="visible" class="toggleAttrsBlk">
        <ul>
          <li v-for="variationEntry in getVariationEntriesOfThisGroupFromVariationGroupData"
              :key="variationEntry.variationId"
              v-on:click="navigateToProduct(variationEntry.variationId)"
              :class="getVariationTextClass(defaultValue, variationEntry)">
            {{ variationEntry.variationName }}
            <span v-if="getVariationOutOfStock(variationEntry)" class="variation-not-available">
            ( {{ t('product_status.unavailable.text') }} )
          </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import variationSelectorMixin from './VariationSelectorMixin'

export default {
  name: 'VariationTextSelector',
  mixins: [variationSelectorMixin],
  data () {
    return {
      version: '0.0.2',
      visible: false
    }
  },
  created () {
    window.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.visible = false
      }
    })
  },
  methods: {
    getVariationOutOfStock (variation) {
      return variation.stock <= 0
    },
    getVariationTextClass (defaultValue, variation) {
      if (defaultValue === variation.variationName) {
        return 'selected'
      } else if (this.getVariationOutOfStock(variation)) {
        return 'disabled'
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .toggleAttrsBlk {
    top: calc(100% - 5px);
    left: 0;
  }
</style>
